// removed by extract-text-webpack-plugin
module.exports = {"text-body":"change-password__text-body___1z-kt"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/settings/change-password/change-password.scss
 ** module id = 1308
 ** module chunks = 1
 **/